import React from "react";
import "./ProjectCard.css";
import MoreIcon from "../icons/MoreIcon";
import ExportIcon from "../icons/ExportIcon";
import EditIcon from "../icons/EditIcon";
import TrashIcon from "../icons/TrashIcon";
import Dropdown from "../ui/Dropdown";
import Badge from "../ui/badges/Badge";
import AvatarGroup from "../ui/AvatarGroup";
import { Project } from "../../types/project";
import { DropdownItem } from "../../types/dropdown";

interface ProjectCardProps {
  project: Project;
  onClick: () => void;
  variant?: "green" | "blue" | "purple" | "orange";
  onExport?: (project: Project) => void;
  onRename?: (project: Project) => void;
  onDelete?: (project: Project) => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  project,
  onClick,
  variant = "green",
  onExport,
  onRename,
  onDelete,
}) => {
  const dropdownItems: DropdownItem[] = [
    ...(project.has_result
      ? [
        {
          id: "export",
          label: "Export",
          icon: <ExportIcon size={18} />,
          onClick: () => onExport?.(project),
        },
      ]
      : []),
    {
      id: "rename",
      label: "Rename",
      icon: <EditIcon size={18} color="#45484f" />,
      onClick: () => onRename?.(project),
    },
    {
      id: "delete",
      label: "Delete",
      icon: <TrashIcon size={18} color="#d31220" />,
      onClick: () => onDelete?.(project),
      variant: "danger",
    },
  ];

  const dropdownTrigger = (
    <button className="more-button" aria-label="More options">
      <MoreIcon size={20} />
    </button>
  );

  const avatars: string[] = [
    // "/avatars/avatar1.png",
    // "/avatars/avatar2.png",
    // "/avatars/avatar3.png",
    // "/avatars/avatar4.png",
  ];

  const projectTag = () => {

    if (project.mode === "chat")
      return "STRATEGY SESSION";

    return project?.metadata?.project_type || "STRATEGY PROJECT";
  };

  const isNew = project.metadata?.is_new || false;
  const createdBy = "Rashid Al-Ahmadi";

  return (
    <div
      className={`project-card project-card--${variant} ${isNew ? "project-card--new" : ""
        }`}
      onClick={onClick}
    >
      <div className="project-card-top">
        {/* Header */}
        <div className="project-card-header">
          <div className="badge-wrapper">
            {isNew && <Badge value="NEW" className="badge-success" />}
            <Badge
              value={projectTag()}
              className="badge-neutral"
            />
          </div>
          <div onClick={(e) => e.stopPropagation()}>
            <Dropdown trigger={dropdownTrigger} items={dropdownItems} />
          </div>
        </div>

        {/* Body */}
        <div className="project-card-body">
          <h3 className="project-title">{project.name}</h3>
          <p className="project-subtitle" title={project.description || undefined}>{project.description}</p>
        </div>
      </div>

      {/* Footer */}
      <div className="project-card-footer">
        {/* <div className="footer-item">
          <span className="footer-label">Created by</span>
          <div className="footer-value">
            <img
              src="/avatars/avatar1.png"
              alt="creator"
              className="creator-avatar"
            />
            <span>{createdBy}</span>
          </div>
        </div> */}

        <div className="footer-item">
          <span className="footer-label">Last updated</span>
          <span className="footer-value">
            {new Date(project.updated_at).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })}{" "}
            |{" "}
            {new Date(project.updated_at).toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>

        {avatars.length > 0 && (
          <div className="footer-item shared">
            <span className="footer-label">Shared with</span>
            <div className="footer-value shared-value">
              <AvatarGroup avatars={avatars} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
